'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import type { TooltipActionType } from '@repo/platform-analytics/types';
export function useProductCardMobileAccordionPageAction() {
  const $ = _c(4);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[2] !== firePageAction) {
    const fireTooltipPageAction = (actionType, actionName, actionSection) => {
      firePageAction({
        action_type: actionType,
        action_name: actionName,
        action_section: actionSection
      });
    };
    t1 = (actionType_0, actionName_0, actionSection_0) => {
      fireTooltipPageAction(actionType_0, actionName_0, actionSection_0);
    };
    $[2] = firePageAction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleTooltipClickPageAction = t1;
  return handleTooltipClickPageAction;
}